module.exports = __webpack_public_path__ + "Images/copyright-vertical.png";


//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/images/copyright-vertical.png
// module id = 1865
// module chunks = 2